import { get } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text, FormElements } from '@custom-components';
import { TableHead, TableBody, TableRow } from '@mui/material';
import { TableWrapper, StyledCell, StyledTable } from './SelectTable.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class Table extends Component {
  constructor(props) {
    super(props);
    this.renderBody = this.renderBody.bind(this);
    this.renderHead = this.renderHead.bind(this);
  }

  isSelected = (id) => {
    const { selected } = this.props;
    return selected.indexOf(id) !== -1;
  };

  renderHead() {
    const { rows, children, headerCellsConfig, handleSelectAllClick, selected } = this.props;
    return (
      <TableHead>
        <TableRow>
          <StyledCell padding="checkbox" style={{ width: '40px' }}>
            <FormElements.Checkbox
              indeterminate={selected.length > 0 && selected.length < children.length}
              checked={selected.length === children.length && selected.length !== 0}
              onChange={handleSelectAllClick}
            />
          </StyledCell>
          {rows &&
            rows.map((row) => {
              const { id, label } = row;
              const cellConfigProps = get(headerCellsConfig, `${id}`, {});
              return (
                <StyledCell key={id} {...cellConfigProps}>
                  <Text.CopyMini noMargins>{label}</Text.CopyMini>
                </StyledCell>
              );
            })}
        </TableRow>
      </TableHead>
    );
  }

  renderBody() {
    const { children, contentCellsConfig, handleSelectClick } = this.props;
    return children ? (
      <TableBody>
        {children.map((child) => {
          const isSelected = this.isSelected(child.id);
          return (
            <TableRow key={child.id} selected={isSelected}>
              <StyledCell padding="checkbox">
                <FormElements.Checkbox checked={isSelected} onChange={(e) => handleSelectClick(e, child.id)} />
              </StyledCell>
              {Object.entries(child).map(([key, item]) => {
                if (key === 'id') return null;
                const cellConfigProps = get(contentCellsConfig, `${key}`, {});
                return (
                  <StyledCell key={key} {...cellConfigProps}>
                    {item}
                  </StyledCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    ) : undefined;
  }

  render() {
    const { minTableWidth } = this.props;
    return (
      <TableWrapper>
        <StyledTable minTableWidth={minTableWidth}>
          {this.renderHead()}
          {this.renderBody()}
        </StyledTable>
      </TableWrapper>
    );
  }
}

Table.propTypes = {
  /** Array of content objects to display in table */
  children: ReactChildrenPropType,
  /** Object with keys matching row object IDs containing @MUITableCell properties and valid td attributes */
  contentCellsConfig: PropTypes.shape({}),
  /** Object with keys matching row object IDs containing @MUITableCell properties and valid td attributes */
  headerCellsConfig: PropTypes.shape({}),
  /** Min width of the table passed via string (900px default) */
  minTableWidth: PropTypes.string,
  /** Array of label objects to display at the top of the table */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      width: PropTypes.string
    })
  ).isRequired,
  handleSelectAllClick: PropTypes.func,
  handleSelectClick: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.number)
};

Table.defaultProps = {
  children: undefined,
  contentCellsConfig: {},
  headerCellsConfig: {},
  minTableWidth: '900px',
  handleSelectAllClick: () => {},
  handleSelectClick: () => {},
  selected: []
};

export default Table;
